import { IconWrapper } from '../runtime';
export default IconWrapper('sticky_note_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#E8B600"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 14H16C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14Z",
      "fill": "#DBAC00"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 14H16C16 15.1046 15.1046 16 14 16H8V14Z",
      "fill": "#F7C200"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M5.90572 10.3089C5.86816 10.3119 5.83094 10.3147 5.79407 10.3173C5.68538 10.325 5.57977 10.3309 5.47743 10.336L4.76314 11.0805C4.5832 11.2836 4.32219 11.4003 4.04768 11.4003L2.5 11.4476L4.43277 9.71842C4.43774 9.6168 4.44478 9.50885 4.45469 9.39539C4.45577 9.38299 4.45689 9.37052 4.45804 9.35799C4.46228 9.31186 4.467 9.26485 4.47225 9.21703C4.58986 8.14542 4.97298 6.66068 6.19698 5.36692C7.47901 4.01183 9.48367 3.30674 10.8958 2.91676C10.9254 2.90859 10.9547 2.90056 10.9838 2.89267L11.0174 2.88356C11.1969 2.83516 11.3651 2.79278 11.5191 2.75598C12.116 2.61338 12.5 2.55469 12.5 2.55469C12.5 2.55469 12.4388 2.93902 12.2899 3.53467C12.2514 3.68856 12.2071 3.85657 12.1564 4.03569L12.1551 4.04041C12.1443 4.07859 12.1332 4.11727 12.1218 4.15642C11.7195 5.54011 10.9539 7.51597 9.63001 8.81321C8.24424 9.96548 6.94357 10.2254 5.90572 10.3089ZM8.62287 7.69944C7.68541 8.46301 6.82741 8.69795 6.05753 8.78731C6.21771 8.02807 6.56078 7.16499 7.28661 6.3978C8.05756 5.58291 9.24367 5.02607 10.3878 4.6397C9.99227 5.73264 9.41445 6.90279 8.62287 7.69944Z",
      "fill": "white"
    }
  })]);
});